function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 6.65H8.85V1.2C8.85 0.974566 8.76045 0.758365 8.60104 0.598959C8.44164 0.439553 8.22543 0.35 8 0.35C7.77457 0.35 7.55836 0.439553 7.39896 0.598959C7.23955 0.758365 7.15 0.974566 7.15 1.2V6.65H1.7C1.47457 6.65 1.25837 6.73955 1.09896 6.89896C0.939553 7.05836 0.85 7.27457 0.85 7.5C0.85 7.72543 0.939553 7.94164 1.09896 8.10104C1.25837 8.26045 1.47457 8.35 1.7 8.35H7.15V13.8C7.15 14.0254 7.23955 14.2416 7.39896 14.401C7.55837 14.5604 7.77457 14.65 8 14.65C8.22543 14.65 8.44164 14.5604 8.60104 14.401C8.76045 14.2416 8.85 14.0254 8.85 13.8V8.35H14.3C14.5254 8.35 14.7416 8.26045 14.901 8.10104C15.0604 7.94164 15.15 7.72543 15.15 7.5C15.15 7.27457 15.0604 7.05837 14.901 6.89896C14.7416 6.73955 14.5254 6.65 14.3 6.65Z",
  fill: "#7B7C7C",
  stroke: "#7B7C7C",
  strokeWidth: 0.3
});

function SvgIcAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default ForwardRef;